import React, { useRef, useState } from 'react';
import { IoCloudUploadOutline } from 'react-icons/io5';
import Styles from './styles.module.css';
import { MAX_PDF_BYTES } from './scanApi';

type Props = {
  disabled?: boolean;
  onFile: (file: File) => void;
  onReject: (message: string) => void;
};

// 将来 JPEG / PNG 対応する場合はここに 'image/jpeg', 'image/png' を追加し、
// scanApi / Cloud Function 側の許可 mimeType も合わせて広げる。
const ACCEPT = ['application/pdf'];

const Dropzone: React.FC<Props> = ({ disabled, onFile, onReject }) => {
  const inputRef = useRef<HTMLInputElement>(null);
  const [dragOver, setDragOver] = useState(false);

  const handleFiles = (files: FileList | null) => {
    if (!files || files.length === 0) return;
    const file = files[0];
    const isPdf = ACCEPT.includes(file.type) || /\.pdf$/i.test(file.name);
    if (!isPdf) {
      onReject('PDFファイルをアップロードしてください。');
      return;
    }
    if (file.size > MAX_PDF_BYTES) {
      onReject(`ファイルサイズが大きすぎます（上限 ${Math.floor(MAX_PDF_BYTES / 1024 / 1024)}MB）。`);
      return;
    }
    onFile(file);
  };

  return (
    <div
      className={`${Styles.dropzone} ${dragOver ? Styles.dropzone_over : ''} ${disabled ? Styles.dropzone_disabled : ''}`}
      onDragOver={(e) => { e.preventDefault(); if (!disabled) setDragOver(true); }}
      onDragLeave={() => setDragOver(false)}
      onDrop={(e) => {
        e.preventDefault();
        setDragOver(false);
        if (disabled) return;
        handleFiles(e.dataTransfer.files);
      }}
      onClick={() => !disabled && inputRef.current?.click()}
      role="button"
      tabIndex={0}
    >
      <input
        ref={inputRef}
        type="file"
        accept="application/pdf"
        hidden
        onChange={(e) => { handleFiles(e.target.files); e.target.value = ''; }}
      />
      <IoCloudUploadOutline className={Styles.dropzone_icon} />
      <p className={Styles.dropzone_title}>求人票のPDFをここにドラッグ＆ドロップ</p>
      <p className={Styles.dropzone_sub}>またはクリックしてファイルを選択（PDF・最大 7MB）</p>
    </div>
  );
};

export default Dropzone;
